import React from "react";
import { Text, View, TouchableOpacity, ScrollView} from "react-native";
import styles from "../../Css";
import stylesResponsive from "../../CssResponsive";
import Modal from "../Modal/modal";
import UIText from "../Text/text";
import ActivityIndicator from "../../components/ActivityIndicator/activityIndicator";

const subscriptionCancelConfirmBox = props => {
  const {styles: stylesRes, ids} = stylesResponsive.getProcessedStyles();
  return (
    <Modal visible={props.visibleModal}>
      <View style={stylesRes.modalScrollWrapperCom} dataSet={{media: ids.modalScrollWrapperCom}}>
        <ScrollView style={styles.modalScroller}>
          <View style={[styles.popUpBlock, styles.bgWhite]}>
            <View style={styles.popUpContentArea}>
              <View style={styles.gridSectionPopup}>
                <View style={[styles.popUpContentPd]}>
                  <View style={stylesRes.modalContIn}>
                    <View style={styles.gridRow}>
                      <View style={styles.gridColFull}>
                        <View
                          style={[styles.infoTitleBlock, styles.infoPdTopBot]}
                        >
                          <Text
                            style={[
                              styles.infoText,
                              styles.text,
                              styles.centerText,
                              styles.bold
                            ]}
                            allowFontScaling={false}
                          >
                            We are sorry to see you go!
                          </Text>
                          <Text
                            style={[
                              styles.infoText,
                              styles.text,
                              styles.centerText,
                              styles.bold
                            ]}
                            allowFontScaling={false}
                          >
                            Your subscription will be canceled on your renewal
                            date.
                          </Text>
                        </View>
                        <View style={[styles.infoBlock, styles.infoPdBotSm]}>
                          <Text
                            style={[
                              styles.infoText,
                              styles.text,
                              styles.centerText,
                              styles.bold
                            ]}
                            allowFontScaling={false}
                          >
                            Remember, you can continue to use the free version
                            and view your historical data but services will be
                            limited.
                          </Text>
                        </View>
                        <View style={[styles.infoBlock, styles.infoPdBotSm]}>
                          <Text
                            style={[
                              styles.infoText,
                              styles.text,
                              styles.centerText
                            ]}
                            allowFontScaling={false}
                          >
                            Are you sure you want to unsubscribe?
                          </Text>
                        </View>
                      </View>
                    </View>

                    <View style={styles.gridRow}>
                      <View style={styles.gridColFull}>
                        <View style={styles.btnArea}>
                          <View style={stylesRes.btnViewSecSm} dataSet={{media: ids.btnViewSecSm}}>
                            <View style={styles.fieldBtn}>
                              <View style={styles.btnBlockFull}>
                                <TouchableOpacity
                                  style={[styles.submitSm]}
                                  underlayColor="rgba(0, 153, 168, 0.8)"
                                  onPress={props.handleCancel}
                                >
                                  <View style={styles.btnSingleView}>
                                    <View
                                      style={[
                                        styles.btnSingle,
                                        styles.btnSingleCent
                                      ]}
                                    >
                                      <UIText
                                        style={styles.submitText}
                                        title="Cancel"
                                      />
                                    </View>
                                  </View>
                                </TouchableOpacity>
                              </View>
                            </View>
                            <View style={styles.fieldBtnSp} />
                            <View style={styles.fieldBtn}>
                              <View style={styles.btnBlockFull}>
                                <TouchableOpacity
                                  style={[styles.submitSm, styles.disableBtn]}
                                  underlayColor="rgba(0, 153, 168, 0.8)"
                                  onPress={props.handleYes}
                                  disabled={props.wait}
                                >
                                  <View style={styles.btnSingleView}>
                                    <View
                                      style={[
                                        styles.btnSingle,
                                        styles.btnSingleCent
                                      ]}
                                    >
                                      {props.wait && (
                                        <View style={styles.actIndSm}>
                                          <ActivityIndicator size="small" />
                                        </View>
                                      )}

                                      <UIText
                                        style={[
                                          styles.submitText,
                                          styles.submitTextSm
                                        ]}
                                        title="Yes"
                                      />
                                    </View>
                                  </View>
                                </TouchableOpacity>
                              </View>
                            </View>
                          </View>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </ScrollView>
      </View>
    </Modal>
  );
};
export default (subscriptionCancelConfirmBox);
